import React, { useMemo } from 'react';
import DashboardCard from '../shared/DashboardCard';
import EmptyState from '../shared/EmptyState';
import styles from '../../../../styles/DashboardV2.module.css';

interface UpcomingRemindersWidgetProps {
    userReminders: { documentReminders: any[], fieldReminders: any[] };
    loading?: boolean;
}

const UpcomingRemindersWidget: React.FC<UpcomingRemindersWidgetProps> = ({
    userReminders,
    loading,
}) => {
    const docReminders = useMemo(() => {
        return [...userReminders.documentReminders].sort((a, b) => {
            if (a.dueDate && b.dueDate) return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
            return 0;
        });
    }, [userReminders]);

    const fieldReminders = useMemo(() => {
        return [...userReminders.fieldReminders].sort((a, b) => {
            if (a.dueDate && b.dueDate) return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
            return 0;
        }); 
    }, [userReminders]);


    const top5Doc = docReminders.slice(0, 5);
    const top5Field = fieldReminders.slice(0, 5);

    return (
        <DashboardCard
            title="Upcoming Reminders"
            loading={loading}
        >
            {top5Doc.length === 0 ? (
                <EmptyState icon="✅" message="No upcoming reminders." />
            ) : (
                <div className={styles.itemList}>
                    {top5Doc.map(r => {
                        return (
                            <div key={r._id} className={styles.listItem}>
                                <div className={styles.listItemContent}>
                                    <div className={styles.listItemTitle}>{r.filing_document_types.name}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {top5Field.length === 0 ? (
                <EmptyState icon="✅" message="No upcoming reminders." />
            ) : (
                <div className={styles.itemList}>
                    {top5Field.map(r => {
                        return (
                            <div key={r.id} className={styles.listItem}>
                                <div className={styles.listItemContent}>
                                    <div className={styles.listItemTitle}>{r.filing_field_types.name}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </DashboardCard>
    );
};

export default UpcomingRemindersWidget;
